import React, { useEffect, useState } from 'react';
import { allNews, getRefreshTokin } from '../api/api';
import './News.css';
import 'antd/dist/antd.css';
import { Table, ConfigProvider } from 'antd';
import ru_RU from 'antd/lib/locale/ru_RU';

const News = () => {
  const [newsGet, setNewsGet] = useState([]);
  const { Column } = Table;
  useEffect(() => {
    const catchError = () => {
      getRefreshTokin()
        .then((res: any) => res.json())
        .then((res: any) => {
          localStorage.access_token = res.access_token;
          allNews()
            .then((res: any) => res.json())
            .then((res: any) => {
              if (res.message) {
                catchError();
              } else {
                setNewsGet(res);
              }
            });
        })
        .catch(() => {
          localStorage.removeItem('access_token');
        });
    };

    allNews()
      .then((res: any) => res.json())
      .then((res: any) => {
        if (res.message) {
          catchError();
        } else {
          setNewsGet(res);
        }
      })
      .catch(catchError);
  }, []);

  return (
    <>
      <section className="news__section">
        <div className="container__news">
          <div className="wrapper__news">
            <ConfigProvider locale={ru_RU}>
              <Table dataSource={newsGet}>
                <Column title="Заголовок" dataIndex="title" key="title" />
                <Column title="Новость" dataIndex="text_news" key="text_news" />
                <Column title="Время" dataIndex="date" key="date" />
              </Table>
            </ConfigProvider>
          </div>
        </div>
      </section>
    </>
  );
};

export default News;
